export const AMPLITUDE_DISABLE = 'disable';
export const AMPLITUDE_DISABLED = 'disabled';
export const AMPLITUDE_ENABLE = 'enable';
export const AMPLITUDE_ENABLED = 'enabled';
export const AMPLITUDE_FALSE = 'false';
export const AMPLITUDE_ON = 'on';
export const AMPLITUDE_TRUE = 'true';
export const CHARACTER_LIMIT_EVENT_NAME = 'setCharacterLimit';
export const CHARACTER_LIMIT_RESET_EVENT_NAME = 'resetCharacterLimit';
export const COVID_TESTING_URL = 'https://testing.providence.org';
export const EVENT_RESTART_CHATBOT = 'restartChatbot';
export const FEEDBACK_TOAST_TIMEOUT_MS = 4 * 1000; // 4 seconds
export const INACTIVE_TIMEOUT_MS = 10 * 60 * 1000; // 10 mins
export const MA_TIMEOUT_EVENT =
    'Message Provider - New message - Grace Timeout';
export const MED_MANAGEMENT_FLOW = 'medication management v2';
export const MESSAGE_SUBJECT = 'subject';
export const USER_BUTTON_CLICK = 'userButtonClick';
export const MESSAGE_LINK = 'link';
export const MYCHART = 'mychart';
export enum TENANTS {
    MYCHART = 'mychart',
    MESSAGE_ASSIST = 'messageassist',
    COVID = 'covid',
    MAIN = 'main',
    POC = 'poc',
}
export const EXCLUDED_REHYDRATION_TENANTS: string[] = [TENANTS.MESSAGE_ASSIST];

export enum MESSAGE_ASSIST_MESSAGE_EVENT_TYPES {
    CANCEL_MESSAGE = 'cancel_message',
    DEEP_LINK = 'deep_link', // allows a user to open a link in the host app's context instead of the current window.
    ERROR = 'error',
    FULFILLMENT_SHOWN = 'fulfillment_shown',
    SHOW_SEND_CONFIRMATION = 'show_send_confirmation',
    ON_GRACE_LOADING_UPDATE = 'on_grace_loading_update',
    ON_GRACE_LOAD_SUCCESS = 'on_grace_load_success',
    ON_GRACE_LOAD_FAIL = 'on_grace_load_fail',
    REQUEST_ACCESS_TOKEN = 'request_access_token',
    SEND_MESSAGE = 'send_message',
    SURVEY_LINK_CLICKED = 'display_survey',
    SURVEY_OPTION_PRESENTED = 'survey_option_presented',
}

export enum MESSAGE_ASSIST_FULFILLMENT_TYPES {
    QNA = 'qna',
    FLOW = 'flow',
}

export const MESSAGE_ASSIST_IFRAME_ID = 'flutter_inappwebview-0';
export const MESSAGE_ASSIST_SCHEMA = 'messageassist://';

export const TIME_SECONDS_LONGER_WAIT_THAN_USUAL = 10; // seconds before "longer than usual" message
export const TIME_SECONDS_TRIGGER_TIMEOUT = 18; // seconds before triggering timeout
